{
    "Umyndig.Pageheading.Engangsstonad": "Application for lump-sum grant",
    "Umyndig.Pageheading.Foreldrepenger": "Application for parental benefit",
    "Umyndig.Pageheading.Svangerskapspenger": "Application for pregnancy allowance",
    "Umyndig.Tittel": "Because you are under 18 years of age, you must send a paper application",
    "Umyndig.Tekst": "Because you are under 18, one of your parents or a guardian must sign your application with you. You must therefore complete the application on paper and send it by post to Nav.",
    "Umyndig.Knapp.Papirsøknad": "Go to the paper application",
    "ErrorSummaryFelles.Tittel": "You have to correct the following errors:",
    "StepButtons.Forrige": "Previous step",
    "StepButtons.ForrigeSimple": "Previous",
    "StepButtons.Neste": "Next step",
    "StepButtons.NesteSimple": "Next",
    "StepButtons.GåTilOppsummering": "Go to summary",
    "StepButtons.GåTilOppsummeringSimple": "Summary",
    "StepButtons.Send": "Send application",
    "ErrorPage.Engangsstønad": "Lump-sum grant",
    "ErrorPage.Foreldrepenger": "Parental benefit",
    "ErrorPage.Svangerskapspenger": "Pregnancy allowance",
    "ErrorPage.Heading": "Sorry, something has gone wrong with your application due to a technical error on our part",
    "ErrorPage.Message": "You can wait a while and then try to search again. If there are still problems, you can contact user support for help.",
    "ErrorPage.Contact": "Contact user support",
    "ErrorPage.TryAgain": "Search again",
    "ErrorPage.ErrorMessage": "Error message",
    "ScanDocumentInfo.Tittel": "How to take a picture of a document with your mobile phone",
    "ScanDocumentInfo.Del1": "If you have a document on paper, you can take a photo of the document and send it to us.",
    "ScanDocumentInfo.Liste.Punkt1": "Take a picture of the document with your smartphone or tablet.",
    "ScanDocumentInfo.Liste.Punkt2": "Check that the document is easy to read.",
    "ScanDocumentInfo.Liste.Punkt3": "Log in to nav.no on your phone and upload your images to your application.",
    "ScanDocumentInfo.Liste.Punkt4": "If you use a PC or Mac, you can send the images to your private email account and save the images on your device.",
    "ScanDocumentInfo.Liste.Punkt5": "Upload and add the images to your electronic application.",
    "ScanDocumentInfo.Del2": "If you have a scanner, you can scan documents.",
    "ScanDocumentInfo.Link": "More information about sending attachments at nav.no.",
    "StepFooter.Avslutt": "Delete application",
    "StepFooter.ContinueLater": "Continue later",
    "AvsluttModal.Tittel": "Continue later",
    "AvsluttModal.Info": "The application is saved and you can complete it later, or choose to delete it. The application is saved for 24 hours.",
    "AvsluttModal.Cancel": "Cancel",
    "AvsluttModal.Delete": "Delete application",
    "FortsettSenereModal.Tittel": "Continue later",
    "FortsettSenereModal.Info": "We will save the information you have provided so far. You can continue your application later.",
    "FortsettSenereModal.Ok": "Ok",
    "SimpleErrorPage.ErrorHeader": "Sorry, it looks like something has gone wrong due to a technical error at Nav",
    "SimpleErrorPage.ErrorBody": "You can try planning again, and if you still get an error, you can wait a bit and come back later.",
    "SimpleErrorPage.TryAgain": "Try planning again",
    "Step.HarValgfrieFelt": "All fields must be filled in, except fields marked with (optional).",
    "Step.HarObligatoriskeFelt": "All fields must be filled in.",
    "FrontPage.Start": "Start",
    "RegisterdataUtdatert.Engangsstønad": "Lump-sum grant",
    "RegisterdataUtdatert.Foreldrepenger": "Parental benefit",
    "RegisterdataUtdatert.Svangerskapspenger": "Pregnancy allowance",
    "RegisterdataUtdatert.StartPaNytt": "Start again",
    "RegisterdataUtdatert.Heading": "Information has changed",
    "RegisterdataUtdatert.Message": "Information about you has changed since you last filled out the application. You must therefore start filling out the application again.",
    "ProgressStepper.ShowSteps": "Show all steps",
    "ProgressStepper.HideSteps": "Hide all steps",
    "ProgressStepper.StepCounter": "Step {activeStep} of {totalSteps}",
    "DekningsgradUtbetalingEksempel.Tittel": "Both options give approximately the same total amount",
    "DekningsgradUtbetalingEksempel.Intro": "The example below uses a monthly salary of NOK 50,000.",
    "DekningsgradUtbetalingEksempel.Rad.Varighet": "Duration:",
    "DekningsgradUtbetalingEksempel.Rad.PerMåned": "Per month:",
    "DekningsgradUtbetalingEksempel.Rad.Totalt": "Total approx.:",
    "DekningsgradUtbetalingEksempel.Hundre.Tittel": "100 % payout",
    "DekningsgradUtbetalingEksempel.Hundre.Varighet": "49 weeks",
    "DekningsgradUtbetalingEksempel.Hundre.PerMåned": "NOK 50,000",
    "DekningsgradUtbetalingEksempel.Hundre.Totalt": "NOK 565,460",
    "DekningsgradUtbetalingEksempel.Atti.Tittel": "80 % payout",
    "DekningsgradUtbetalingEksempel.Atti.Varighet": "61 weeks + 1 day",
    "DekningsgradUtbetalingEksempel.Atti.PerMåned": "NOK 40,000",
    "DekningsgradUtbetalingEksempel.Atti.Totalt": "NOK 564,876",
    "DekningsgradUtbetalingEksempel.Fotnote": "With this salary, the difference is NOK 584. Holiday pay is also approximately the same for both options.",
    "DekningsgradUtbetalingEksempel.Link": "Calculate how much you can receive at nav.no"
}
